const mobileContent = document.querySelectorAll(".announcement-top-bar .mobile-links > a, .announcement-top-bar .mobile-links > p, .announcement-top-bar .mobile-links > div");
const linksAmount = mobileContent.length;
const linksInterval = document.querySelector('.announcement-top-bar').getAttribute('links-interval') || 5000;

if (linksAmount > 1) {
  displayElement(0);

  (function () {
    var index = 0;
    setInterval(function () {
      let elementToHide = index;
      index = index >= linksAmount - 1 ? 0 : index + 1;
      let elementToShow = index;
      hideElement(elementToHide);
      displayElement(elementToShow);
    }, linksInterval);
  })();
} else if (linksAmount === 1) {
  displayElement(0);
}

function displayElement(index) {
  mobileContent[index].classList.remove("hidden");
}

function hideElement(index) {
  mobileContent[index].classList.add("hidden");
}

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('#shopify-section-poloclub-header') || document.querySelector('#shopify-section-header');
  const announcementBar = document.querySelector('.announcement-bar');
  const announcementTopBar = document.querySelector('#shopify-section-announcement-top-bar');
  if(header) {
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }
  if(announcementBar) {
    document.documentElement.style.setProperty('--announcement-height', `${announcementBar.offsetHeight}px`);
  }
  if(announcementTopBar) {
    document.documentElement.style.setProperty('--announcement-top-height', `${announcementTopBar.offsetHeight}px`);
  }
})